import * as Raven from 'raven-js';

// Exposing this for easier debugging in production
window.DISCO_RELEASE = DISCO_RELEASE;

if (SENTRY_CONFIG) {
  Raven
    .config(SENTRY_CONFIG, {
      release: DISCO_RELEASE,
      whitelistUrls: [
        /reverb\.com/,
        /static\.reverb-assets\.com/,
      ],
      ignoreErrors: [
        // https://github.com/SamsungInternet/support/issues/56
        'document.getElementsByClassName.ToString',
        'Blocked a frame with origin "https://reverb.com" from accessing a cross-origin frame.',
        'Blocked a frame with origin "https://reverb.com" from accessing a frame with origin "https://dis.us.criteo.com". Protocols, domains, and ports must match.',
        'Blocked a frame with origin "https://reverb.com" from accessing a frame with origin "https://www.youtube.com". Protocols, domains, and ports must match.',
        'Blocked a frame with origin "https://reverb.com" from accessing a frame with origin "https://staticxx.facebook.com". The frame being accessed set "document.domain" to "facebook.com", but the frame requesting access did not. Both must set "document.domain" to the same value to allow access.',
        'Blocked a frame with origin "https://reverb.com" from accessing a frame with origin "https://bid.g.doubleclick.net". Protocols, domains, and ports must match.',
        'Blocked a frame with origin "https://reverb.com" from accessing a frame with origin "https://gum.criteo.com". Protocols, domains, and ports must match.',
        'Blocked a frame with origin "https://reverb.com" from accessing a frame with origin',
        // https://bugs.chromium.org/p/chromium/issues/detail?id=460399
        // Specific to Safari's removeTag function
        'SyntaxError: The string did not match the expected pattern.',
        'Can\'t find variable: $zopim',
        'SecurityError',
        'No Error',
        'Microsoft Internet extensions',
        'Permission denied',
        'NS_ERROR_STORAGE_BUSY',
        'NS_ERROR_FAILURE',
        'webkitExitFullScreen',
        "Cannot read property 'DOMNodeInsertedByJs' of undefined",
        'Error/C:/Users/',
        'Cannot find function getClientRects in object',
        'Criteo-ads-d ',
        "TypeError: null is not an object (evaluating 'item.obj[item.propName]')",
        'pktAnnotationHighlighter',
        'NS_ERROR_FILE_CORRUPTED',
        /ytsubscribe/,
        'xsca',
        'Out of memory',
        '__firefox__',
        '__gCrWeb',
        /moz-extension/,
        'px2/client.js',
        'can\'t redefine non-configurable property "userAgent"',
        'Unexpected token }',
        'illegal character',

        // Known UI bug reloading CSP tiles, silencing until we fix
        'amountCents',
        't is null',
        'CSP price is null',
      ],
      ignoreUrls: [
        // https://gist.github.com/impressiver/5092952
        // Facebook flakiness
        /graph\.facebook\.com/i,
        // Facebook blocked
        /connect\.facebook\.net\/en_US\/all\.js/i,
        // Woopra flakiness
        /eatdifferent\.com\.woopra-ns\.com/i,
        /static\.woopra\.com\/js\/woopra\.js/i,
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i,
        // Other plugins
        /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
        /webappstoolbarba\.texthelp\.com\//i,
        /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
        /v2\.zopim.com\/bin\/v\/widget\//i,
      ],
    }).install();
}



// WEBPACK FOOTER //
// ./javascripts/components/sentry.js